<template>
  <div>
    <template>
      <v-snackbar :color="snackbar.color" v-model="snackbar.show" :timeout="snackbar.timeout || 2000">
        {{ snackbar.text }}
        <template #action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false"> Close </v-btn>
        </template>
      </v-snackbar>
    </template>
  </div>
</template>
<script>
import eventBus from '../main'
export default {
  data () {
    return {
      // snackbar
      snackbar: {
        show: false,
        color: null,
        text: '',
        timeout: 0
      }
    }
  },
  mounted () {
    this.$root.$on('snackbar', (data) => {
      Object.assign(this.snackbar, { ...data, show: true })
    })
    eventBus.$on('snackbar', (payload) => {
      Object.assign(this.snackbar, { ...payload, show: true })
    })
  },
  beforeDestroy () {
    this.$root.$off('snackbar')
    eventBus.$off('snackbar')
  }
}
</script>